<section class="transaction-history">
    <h3 class="section-heading">Transaction History</h3>
    @if (history.length === 0) {
        <p class="empty-message">No history</p>
    } @else {
        <div class="table-container">
            <table class="data-table">
                <thead>
                    <tr>
                        <th class="table-header">ACH Status</th>
                        <th class="table-header">Date and Time</th>
                        <th class="table-header">Updated by</th>
                    </tr>
                </thead>
                <tbody>
                    @for (entry of sortedHistory; track entry.dateTime) {
                        <tr class="table-row">
                            <td class="table-cell">
                                <ach-status-badge [status]="entry.achStatus" />
                            </td>
                            <td class="table-cell">{{ entry.dateTime | date:'MM/dd/yyyy hh:mm:ss a' }}</td>
                            <td class="table-cell">{{ entry.updatedBy }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
</section>
